import React, { useContext, useMemo } from 'react';

import TabTable from 'components/common/tabs/table';

function Vehicles({ context }) {
  const { data } = useContext(context);
  const rows = useMemo(() => {
    if (data && data.vehicles) {
      return data.vehicles.map((item, index) => {
        return {
          ...item,
          id: index,
        };
      });
    }
    return [];
  }, [data]);

  return (
    <TabTable
      schema={[
        {
          id: 'chassis_number',
          isId: true,
          label: '底盤號碼',
          editable: false,
        },
        {
          id: 'print_number',
          label: '車身編號',
        },
        {
          id: 'vehicle_class',
          label: '類別',
        },
        {
          id: 'effective_date',
          label: '擁有日期',
          type: 'date',
        },
        {
          id: 'end_date',
          label: '售出日期',
          type: 'date',
        },
        {
          id: 'value',
          label: '價值',
        },
        {
          id: 'current_reg_mark',
          label: '車牌號碼',
        },
      ]}
      setting={{
        addable: false,
        editable: false,
        deletable: false,
      }}
      collectionId={data._id}
      rows={rows}
    />
  );
}

export default Vehicles;
